(function () {
  let sliders = [];

  function initThumbnailSliders() {
    sliders.forEach((s) => s.destroy(true, true));
    sliders = [];

    // Swiper misura il "viewport" leggendo il clientHeight dell'elemento
    // passato al costruttore (this.el.clientHeight in updateSize). Deve quindi
    // essere il riquadro che delimita/taglia solo la lista (.product-gallery__thumb-viewport),
    // NON il contenitore esterno .product-gallery__thumbs: quello include anche
    // le frecce e i gap che le distanziano dalla lista, quindi il suo clientHeight
    // è più alto dell'area realmente visibile. Passandolo per errore come
    // container, Swiper pensa di avere più spazio di quanto ne abbia il track
    // e si ferma prima di portare l'ultima slide a fondo.
    document.querySelectorAll('.product-gallery__thumb-viewport.swiper').forEach((container) => {
      const wrapper = container.closest('.product-gallery__thumbs');
      const track = container.querySelector('.product-gallery__thumb-track');
      const upButton = wrapper ? wrapper.querySelector('.product-gallery__thumb-nav--up') : null;
      const downButton = wrapper ? wrapper.querySelector('.product-gallery__thumb-nav--down') : null;

      // Swiper calcola quanto scorrere sommando le dimensioni delle slide +
      // spaceBetween: ignora il gap CSS del contenitore. Il gap nativo è quindi
      // azzerato in CSS (vedi _main-product.scss) e il valore reale (rvw(),
      // responsive) viene letto da column-gap - inerte in flex-direction:column,
      // serve solo a esporre il valore già risolto in px a getComputedStyle.
      const gap = track ? parseFloat(getComputedStyle(track).columnGap) || 0 : 0;

      const slider = new Swiper(container, {
        // Nessuna classe standard swiper-wrapper/swiper-slide nel markup:
        // usiamo le nostre classi (vedi .product-gallery__thumb-* in _main-product.scss).
        wrapperClass: 'product-gallery__thumb-track',
        slideClass: 'product-gallery__thumb',
        direction: 'vertical',
        slidesPerView: 'auto',
        spaceBetween: gap,
        // Nasconde automaticamente le frecce quando le immagini sono poche e
        // il contenuto non supera l'altezza del viewport (≤4 immagini): un
        // solo codice gestisce sia il caso "poche immagini" che "tante immagini".
        watchOverflow: true,
        // Solo le frecce controllano lo slider: niente drag/swipe ne rotella
        // (il modulo Mousewheel non è nemmeno abilitato, quindi la rotella
        // e il touchpad non hanno alcun effetto).
        allowTouchMove: false,
        navigation: {
          nextEl: downButton || null,
          prevEl: upButton || null,
        },
      });
      // Esposto cosi media-gallery.js puo chiamare swiper.slideTo(index) per
      // portare in vista la thumbnail attiva quando è fuori dalla finestra
      // visibile (es. dopo un cambio variante o un click sulle frecce
      // dell'immagine principale).
      container.swiper = slider;

      sliders.push(slider);
    });
  }

  initThumbnailSliders();

  document.addEventListener('page:loaded', initThumbnailSliders);
  subscribe(PUB_SUB_EVENTS.variantChange, initThumbnailSliders);
})();
